import { Collapse, CollapseProps } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// components
import Icon from 'utils/icon';
import DataRoomItem from '../components/dataRoomItem';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import FilePreview from 'components/filePreview/filePreview';

//styles
import { CollapseItemStyles } from 'utils/styles/collapseItem';

// services
import { onGetCompanyDocuments } from '../services/dataRoomServices';
import NotificationService from 'core/services/notification';
import { isRTL } from 'core/services/language';

interface DataRoomPageProps {}

// frontend translations for the document titles, the backend titles are not translated
const DOCUMENT_TITLES: Record<string, string> = {
	company_establishment_contract: 'DOCUMENTS.COMPANY_ESTABLISHMENT',
	tax_registration_certificate: 'DOCUMENTS.VAT_REGISTRATION',
	commercial_register: 'DOCUMENTS.COMMERCIAL_REGISTRATION',
	company_representative_certified_authorization: 'DOCUMENTS.APPROVED_AUTHORIZATION',
	board_committees: 'DOCUMENTS.BOARD_COMMITMENT',
	board_of_directors: 'DOCUMENTS.BOARD_OF_DIRECTORS',
	license: 'ACTIONS.LICENSES',
	contract: 'COMMON.CONTRACT',
};

const DataRoomPage: FunctionComponent<DataRoomPageProps> = () => {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [dataRoomFiles, setDataRoomFiles] = useState<CollapseProps['items']>([]);

	useEffect(() => {
		getDataRoomFiles();
	}, []);

	const getDataRoomFiles = async () => {
		try {
			setIsLoading(true);

			const response = await onGetCompanyDocuments();

			const files: CollapseProps['items'] = [];

			Object.entries(response).forEach(([key, value]) => {
				files.push({
					key,
					label: (
						<FilePreview
							name={DOCUMENT_TITLES[key] ? t(DOCUMENT_TITLES[key]) : isRTL() ? value.translated_title.ar : value.translated_title.en}
							transparent
						/>
					),
					children: <DataRoomItem file={value} />,
					style: CollapseItemStyles,
				});
			});

			setDataRoomFiles(files);

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
		}
	};

	return isLoading ? (
		<LoadingComponent />
	) : (
		<Collapse
			bordered={false}
			expandIconPosition="end"
			className="file-room"
			style={{ background: 'transparent' }}
			expandIcon={({ isActive }) => (
				<Icon
					name="rightArrow"
					height={18}
					color="#555"
					style={{ transition: 'all .2s ease-in-out', transform: isActive ? 'rotate(-90deg)' : 'rotate(90deg)' }}
				/>
			)}
			items={dataRoomFiles}
		/>
	);
};

export default DataRoomPage;
